
import { defineComponent, onMounted, ref, computed, provide, inject } from 'vue'
import { useRoute } from 'vue-router';
import { useI18n } from "vue-i18n/index";
//components
import ModalClubs from "@/components/modals/general/ModalSport.vue"

import eventService from "@/core/services/EventService";
import masterService from "@/core/services/MasterService";
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "acrd-sports",
    components: {
        ModalClubs,
    },
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const { id } = route.params
        const evento = inject<any>("evento")
        const loader = ref(false)
        const search = ref('')
        const listSports = ref<any>([])
        const listStatus = ref<any>([])
        const itemSport = ref(<any> {})
        const dialogSport = ref(false)
        //shared
        provide("dialogSport", dialogSport)

        //lista de deportes por evento
        const getSports = async () => {
            loader.value = true
            listSports.value.length = 0
            await eventService.getSports({idevent:id})
            .then ( (res) => {
                listSports.value = res.data
                loader.value = false
            }).catch ( ({ response }) => {
                loader.value = false
                errManager(response)
            })
        }

        //lista de estados de acreditacion
        const getStatus = async () => {
            await masterService.Details("api", btoa("6"))
            .then( (res) => {
                listStatus.value.length = 0
                listStatus.value = res.data
            }).catch( ({response}) => {
                errManager(response)
            })
        }

        const filteredSports = computed(() => {
            return listSports.value.filter(
                (item) => (item.name && item.name.toLowerCase().includes(search.value.toLowerCase()))
            );
        });

        const onDialogSport = (item) => {
            itemSport.value = item
            dialogSport.value = true
        }

        onMounted(()=>{
            getSports()
            getStatus()
        })

        return {
            t,
            id,
            evento,
            loader,
            search,
            listSports, 
            listStatus,
            itemSport,
            dialogSport,
            //events
            getSports,
            filteredSports,
            onDialogSport
        }
        
    },
})
